// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright (c) 2025 Robert Schiwon
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

/* menu */

sf-menu {
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
}

/* menu items */

sf-menu-item,
sf-menu-item-file-open,
sf-submenu {
  display: flex;
  position: relative;
}

sf-menu button {
  background: none;
  color: inherit;
  border: none;
  font: inherit;
  outline: inherit;
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;
  padding: 0.25em 0.5em 0.25em 0.5em;
  width: 100%;
  box-sizing: border-box;
  outline-offset: -0.2em;
}

sf-menu button:hover {
  background-color: #ddd;
}

/* mobile */

@media screen and (max-width: 576px) {
  sf-menu {
    position: absolute;
    display: block;
    opacity: 0;
    visibility: hidden;
  }

  sf-menu.sf-show-menu {
    opacity: 1;
    visibility: visible;
    transition: opacity 0.1s ease-in;
  }

  sf-menu-item,
  sf-menu-item-file-open,
  sf-submenu {
    display: block;
    box-sizing: border-box;
    background-color: #eee;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/menu/Menu.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;EAmBE;;AAEF,SAAS;;AAET;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA,eAAe;;AAEf;;;EAGE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,WAAW;EACX,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,WAAW;;AAEX;EACE;IACE,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;;;IAGE,cAAc;IACd,sBAAsB;IACtB,sBAAsB;EACxB;AACF","sourcesContent":["/**\n * Copyright (c) 2025 Robert Schiwon\n *\n * Permission is hereby granted, free of charge, to any person obtaining a copy of\n * this software and associated documentation files (the \"Software\"), to deal in\n * the Software without restriction, including without limitation the rights to\n * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\n * the Software, and to permit persons to whom the Software is furnished to do so,\n * subject to the following conditions:\n *\n * The above copyright notice and this permission notice shall be included in all\n * copies or substantial portions of the Software.\n *\n * THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\n * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\n * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\n * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\n * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.\n */\n\n/* menu */\n\nsf-menu {\n  display: flex;\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n}\n\n/* menu items */\n\nsf-menu-item,\nsf-menu-item-file-open,\nsf-submenu {\n  display: flex;\n  position: relative;\n}\n\nsf-menu button {\n  background: none;\n  color: inherit;\n  border: none;\n  font: inherit;\n  outline: inherit;\n  cursor: pointer;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  padding: 0.25em 0.5em 0.25em 0.5em;\n  width: 100%;\n  box-sizing: border-box;\n  outline-offset: -0.2em;\n}\n\nsf-menu button:hover {\n  background-color: #ddd;\n}\n\n/* mobile */\n\n@media screen and (max-width: 576px) {\n  sf-menu {\n    position: absolute;\n    display: block;\n    opacity: 0;\n    visibility: hidden;\n  }\n\n  sf-menu.sf-show-menu {\n    opacity: 1;\n    visibility: visible;\n    transition: opacity 0.1s ease-in;\n  }\n\n  sf-menu-item,\n  sf-menu-item-file-open,\n  sf-submenu {\n    display: block;\n    box-sizing: border-box;\n    background-color: #eee;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
